module.exports = __webpack_public_path__ + "img/new-consult5.eaf35037.png";